<router-outlet *ngIf="!isFakeMode;else placeholder" xmlns="http://www.w3.org/1999/html"></router-outlet>
<ng-template #placeholder>
  <section class="main-ecommerce">
    <db-ecommerce-subscribe-banner
      [isNavigationPage]="true"
      (openCheckout)="showCheckoutDialog('Navigation')">
    </db-ecommerce-subscribe-banner>
    <db-add-ecommerce-menu [isDemo]="true"></db-add-ecommerce-menu>
  </section>
</ng-template>
